import { ROUTE_ARTICLE, ROUTE_SEARCH, ROUTE_STORY } from '@constants';
import { TrackEvent } from '@enums';
import { Enum_Modals_Trigger } from '@graphql/generated/graphql';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { getLastVisited, updateLastVisited } from '@utils/lastVisited';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useTriggerEventContext } from '../contexts/TriggerEventContext';

const InitRouter = () => {
    const { track } = useAnalytics();
    const { onTriggerEvent } = useTriggerEventContext();
    const router = useRouter();
    const {
        asPath,
        pathname,
        query: { company, product },
    } = router;

    useEffect(() => {
        const lastVisited = getLastVisited(company);

        if (!Object.keys(lastVisited).length) {
            track(TrackEvent.FirstVisit, {
                company: company as string,
            });
            onTriggerEvent({ event: Enum_Modals_Trigger.FirstVisit });
            updateLastVisited(company, 'global');
        }
    }, [company, onTriggerEvent, track]);

    useEffect(() => {
        const triggerEvents = (targetUrl: string) => {
            const slugRegex = /(story|article)\/(?<slug>[\w-]+)/;

            // Handle exitStory
            if (pathname === ROUTE_STORY && !targetUrl.includes('/story/')) {
                onTriggerEvent({
                    event: Enum_Modals_Trigger.ExitStory,
                    filters: {
                        story_slug: slugRegex.exec(asPath)?.groups?.slug,
                    },
                });
            }

            // Handle enterStory
            if (pathname !== ROUTE_STORY && targetUrl.includes('/story/')) {
                onTriggerEvent({
                    event: Enum_Modals_Trigger.EnterStory,
                    filters: {
                        story_slug: slugRegex.exec(targetUrl)?.groups?.slug,
                    },
                });
            }

            // Handle exitArticle
            if (
                pathname === ROUTE_ARTICLE &&
                !targetUrl.includes('/article/')
            ) {
                onTriggerEvent({
                    event: Enum_Modals_Trigger.ExitArticle,
                    filters: {
                        article_slug: slugRegex.exec(asPath)?.groups?.slug,
                    },
                });
            }

            // Handle enterArticle
            if (pathname !== ROUTE_ARTICLE && targetUrl.includes('/article/')) {
                onTriggerEvent({
                    event: Enum_Modals_Trigger.EnterArticle,
                    filters: {
                        article_slug: slugRegex.exec(targetUrl)?.groups?.slug,
                    },
                });
            }

            // Handle search action
            if (pathname !== ROUTE_SEARCH && targetUrl.includes('/search')) {
                onTriggerEvent({
                    event: Enum_Modals_Trigger.OnSearch,
                    filters: { product },
                });
            }
        };

        router.events.on('routeChangeStart', triggerEvents);

        return () => {
            router.events.off('routeChangeStart', triggerEvents);
        };
    });

    return null;
};

export default InitRouter;
